export function percent(flt) {
  return Math.ceil(flt * 100)
}
